module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Pillar-Page-Resource-w540.4ab0aa52.jpg";